// Copyright 2023 Huawei Cloud Computing Technology Co., Ltd.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import VideoEncode from '../codec/Encode';
import { mat4 } from 'gl-matrix';

const videoEncoder =  new VideoEncode();

self.addEventListener('message', evt => {
    const message = evt.data;
    switch (message.type) {
        case 'initEncode': {
            videoEncoder.getWasm({
                width: message.width,
                height: message.height,
                x264WasmPath: message.x264WasmPath
            });
            break;
        }
        case 'encode': {
            videoEncoder.encode(message.data);
            break;
        }
        case 'rotateTexture': {
            let rotationMatrix = mat4.create();
            mat4.rotateZ(rotationMatrix, rotationMatrix, message.rotateAngles);
            self.postMessage({
                type: 'setRotateData',
                data: rotationMatrix
            });
            break;
        }
        default:
            // do nothing
    }
});

export default function() {}